import { render, staticRenderFns } from "./EditPlatformtemplateMappingComponent.vue?vue&type=template&id=22771014&"
import script from "./EditPlatformtemplateMappingComponent.vue?vue&type=script&lang=js&"
export * from "./EditPlatformtemplateMappingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports